import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';

import { LoadingBarModule } from '@ngx-loading-bar/core';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { constants } from './shared/constants/constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, LoadingBarModule, ConfirmDialogModule, ConfirmPopupModule, AngularFireModule ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: []
})
export class AppComponent implements OnInit, AfterViewInit {
  loaderColor!: string;

  constructor(private primengConfig: PrimeNGConfig, private titleService: Title) { }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.titleService.setTitle(environment.title);
    const favicon = document.getElementById('appFavicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = environment.favicon;
    }
    if (environment.isPWCEnabled) {
      document.documentElement.classList.add('pwc');
      this.loaderColor = constants.pwcPrimaryColor;
    } else {
      document.documentElement.classList.remove('pwc');
      this.loaderColor = constants.staftrPrimaryColor;
    }
    this.storageChangeEventListner();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setLoaderColor();
    }, 0);
  }

  private setLoaderColor() {
    const computedColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--loader-color')
      .trim();
    
    if (computedColor) {
      this.loaderColor = computedColor;
    }
  }

  storageChangeEventListner(){
    window.addEventListener('storage', (event) => {
      if (event.key === 'isLoggedOut') {
        setTimeout(() => {
          window.location.href = `${environment.clientHost}login`;
        }, 2000);
      }
    })
  }
}
